import NavigationLinkInteractionEvent, {
  type NavigationLinkModuleType,
  type NavigationLinkPlacement
} from '~/events/NavigationLinkInteractionEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

export type NavigationLinkDetails = {
  ancestorLabels?: string[];
  label?: string;
  modulePosition?: number;
  moduleType?: NavigationLinkModuleType;
};

export default function useNavigationLinkInteraction(
  placement: NavigationLinkPlacement
) {
  const { isBot } = useRootData();
  const user = useUser();

  return (
    href: string,
    position: number,
    details: NavigationLinkDetails = {}
  ) =>
    new NavigationLinkInteractionEvent({
      ...details,
      gesture: 'click',
      guestId: user.guestId,
      href,
      isBot,
      placement,
      position
    }).send();
}
